module.exports = __webpack_public_path__ + "img/fw_icon.dfe6291.png";